import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Contract } from '../classes';
import { ContractService } from '../services/contract.service';

@Pipe({
  name: 'contract'
})
export class ContractPipe implements PipeTransform {

  constructor(private _contractService: ContractService){ }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return of(null);
    return this._contractService.getContractById(value, true).pipe(map((contract: Contract) => [contract.contractnumber, contract.contractdesc].filter(x => x).join(' ')));
  }

}
